import { call, select, takeEvery } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalPut,
  KuendigungenChanged,
  RbdChanged,
  TreuebonusChanged,
  VorteilsrabattPayload,
} from '@ps20-frontend/shop-integration-redux';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { ToolbarActions } from '../toolbar.actions';
import { IAppState } from '../toolbarState';

export function* watchVereinbarungenUebernehmen() {
  yield takeEvery(
    ToolbarActions.VEREINBARUNGEN_UEBERNEHMEN,
    safeSaga(vereinbarungenUebernehmenSaga, App.SHOP_TOOLBAR),
  );
  yield takeEvery(
    GlobalActions.UPDATE_RECEIVED_VORTEILNACHLASS,
    safeSaga(vereinbarungenUebernehmenSaga, App.SHOP_TOOLBAR),
  );
}

export function* vereinbarungenUebernehmenSaga() {
  const state: IAppState = yield select();
  const payloadRbd: RbdChanged[] = state.rbd
    .filter(value => value.rbd_changed !== value.rbd_aktuell)
    .map(elem => {
      return {
        appId: elem.appId,
        angebotsId: elem.angebotsId,
        rbd: elem.rbd_changed,
      };
    });

  const payloadTb: TreuebonusChanged[] = state.treuebonus
    .filter(value => value.treuebonus_changed !== value.treuebonus_aktuell)
    .map(treuebonus => {
      return {
        appId: treuebonus.appId,
        angebotsId: treuebonus.angebotsId,
        treuebonus: treuebonus.treuebonus_changed,
      };
    });

  const payloadKuendigungen: KuendigungenChanged[] = state.vorliegendeKuendigungen
    .filter(value => value.gekuendigtTemp !== value.gekuendigt)
    .map(elem => {
      return {
        appId: elem.appId,
        angebotsId: elem.angebotsId,
        vorvertragsnummer: elem.vorvertragsnummer,
      };
    });
  const vorteilsRabattProdukte: Array<VorteilsrabattPayload> = state.vorteilsrabatt.produkte.map(
    vrProdukt => {
      return {
        appId: vrProdukt.appId,
        angebotsId: vrProdukt.angebotsId,
        rabattInProzent: vrProdukt.rabattInProzent,
      };
    },
  );

  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put,
    new GlobalActions().vereinbarungenChanged(
      payloadRbd,
      payloadTb,
      payloadKuendigungen,
      vorteilsRabattProdukte,
    ),
  );
}
